import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "../../../services/apiService";
import { toast } from "react-toastify";
import Add from "../../table/Add";

const AddWua = () =>{ 
    const [dropdownOpen,setDropdownOpen] = useState(false);
    const navigate = useNavigate();
   
    
      const onSubmit = async (data :any) => {
        try{
            
            const response = await ApiService.axiosApi("/wua",{
                method: "POST",
                data: data,
            })
            if(response.success){
                
                toast.success(response.message);
                navigate(-1);
            }else{
                toast.error(response.message);
            }
        }catch(error){
            console.log(error);
        }
      }
    
     
      const toggleDropdown = () => setDropdownOpen(prev => !prev);

    return (
         <>
             <Add
         title = {'Add Wua'}
         parentTitle = {'Wua'}
         onSubmit = {onSubmit}

         fields = {[
             {
              name : "HeadQuaterName",
              label  :"Wua",
              type: "text",
              validation :  { required: "Wua is required" }
             },  
         ]}
        />
         </>
    )
}
export default AddWua;
